import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import App from "./App";
import { SileoProvider } from "./components/Sileo";
import "./index.css";
import "./styles/home.css";
import "./styles/auth.css";

const resolveWebBasename = () => {
  const baseFromVite = import.meta.env.BASE_URL || "/";
  if (baseFromVite === "./" || baseFromVite === "/") return "/";
  return baseFromVite.endsWith("/") ? baseFromVite.slice(0, -1) : baseFromVite;
};

const Router = Capacitor.isNativePlatform() ? BrowserRouter : HashRouter;
const basename = Capacitor.isNativePlatform() ? "/" : resolveWebBasename();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SileoProvider>
      <Router basename={basename}>
        <App />
      </Router>
    </SileoProvider>
  </React.StrictMode>
);
